import {
  addSurveySchedule,
  getSurveySchedule,
  getSurveyResponseTimeLeft,
  patchSurveySchedule
} from '../api';

export const ADD_SURVEY_SCHEDULE = 'ADD_SURVEY_SCHEDULE';
export const GET_REMAINING_RESPONSE_TIME = 'GET_REMAINING_RESPONSE_TIME';
export const GET_SURVEY_SCHEDULE = 'GET_SURVEY_SCHEDULE';
export const UPDATE_SURVEY_SCHEDULE = 'UPDATE_SURVEY_SCHEDULE';

export const addSurveyScheduleAction = (surveyId, data) => ({
  type: ADD_SURVEY_SCHEDULE,
  payload: addSurveySchedule(surveyId, data)
});

export const getSurveyResponseTimeLeftAction = (surveyId) => ({
  type: GET_REMAINING_RESPONSE_TIME,
  payload: getSurveyResponseTimeLeft(surveyId)
});

export const getSurveyScheduleAction = (surveyId) => ({
  type: GET_SURVEY_SCHEDULE,
  payload: getSurveySchedule(surveyId)
});

export const updateSurveyScheduleAction = (surveyId, data) => ({
  type: UPDATE_SURVEY_SCHEDULE,
  payload: patchSurveySchedule(surveyId, data)
});
